import { axios } from "../config";

function fetchTerms(params) {
  return axios.get("/api/v1/terms", { params });
}

function fetchActivityClassName(params) {
  return axios.get("/api/v1/class/classrooms-with-levels", { params });
}

function fetchActivityRoutine(id, params) {
  return axios.get(`/api/v1/class/routines-by-classroom/${id}`, {
    params
  });
}

function createTerms(data) {
  return axios.post("/api/v1/terms", data);
}

function updateTerms(id, data) {
  return axios.post(`/api/v1/terms/${id}`, data);
}

function deleteTerms(id) {
  return axios.delete(`/api/v1/terms/${id}`);
}

function createAcademicYears(data) {
  return axios.post("/api/v1/academic-years", data);
}

function updateAcademicYears(id, data) {
  return axios.post(`/api/v1/academic-years/${id}`, data);
}

function deleteAcademicYears(id) {
  return axios.delete(`/api/v1/academic-years/${id}`);
}

function createDepartment(data) {
  return axios.post("/api/v1/departments", data);
}

function updateDepartment(id, data) {
  return axios.post(`/api/v1/departments/${id}`, data);
}

function deleteDepartment(id) {
  return axios.delete(`/api/v1/departments/${id}`);
}

function fetchGradeScales(data) {
  return axios.get("/api/v1/grade-scales", {
    params: data,
  });
}

function createGradeScales(data) {
  return axios.post("/api/v1/grade-scales", data);
}

function updateGradeScales(id, data) {
  return axios.put(`/api/v1/grade-scales/${id}`, data);
}

function deleteGradeScales(id) {
  return axios.delete(`/api/v1/grade-scales/${id}`);
}

function fetchCourseworkType(data) {
  return axios.get("/api/v1/coursework-type", {
    params: data,
  });
}

function createCourseworkType(data) {
  return axios.post("/api/v1/coursework-type", data);
}

function updateCourseworkType(id, data) {
  return axios.put(`/api/v1/coursework-type/${id}`, data);
}

function deleteCourseworkType(id) {
  return axios.delete(`/api/v1/coursework-type/${id}`);
}

function fetchRooms(data) {
  return axios.get("/api/v1/rooms", {
    params: data,
  });
}

function createRooms(data) {
  return axios.post("/api/v1/rooms", data);
}

function updateRooms(id, data) {
  return axios.put(`/api/v1/rooms/${id}`, data);
}

function deleteRooms(id) {
  return axios.delete(`/api/v1/rooms/${id}`);
}

function fetchSchoolStatistics(data) {
  return axios.get("/api/v1/analytics/institution-statistics", {
    params: data,
  });
}

export {
  fetchTerms,
  createTerms,
  updateTerms,
  deleteTerms,
  createAcademicYears,
  updateAcademicYears,
  deleteAcademicYears,
  createDepartment,
  updateDepartment,
  deleteDepartment,
  fetchGradeScales,
  createGradeScales,
  updateGradeScales,
  deleteGradeScales,
  fetchCourseworkType,
  createCourseworkType,
  updateCourseworkType,
  deleteCourseworkType,
  fetchRooms,
  createRooms,
  updateRooms,
  deleteRooms,
  fetchSchoolStatistics,
  fetchActivityClassName,
  fetchActivityRoutine,
};
